// src/LoginPage.js
import React, { useState } from 'react';
import axios from 'axios';
import '@tabler/core/dist/css/tabler.min.css';
import './LoginPage.css';

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await axios.post('/api/login', { email, password });
            if (response.data.success) {
                // Guardamos el token y la información del usuario
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('isAuthenticated', 'true');
                if (response.data.user) {
                    localStorage.setItem('user', JSON.stringify(response.data.user));
                }
                window.location.href = '/conversations'; // Redirigimos a conversaciones
            }
        } catch (err) {
            console.error('Error en login:', err);
            setError(err.response?.data?.error || 'Error al iniciar sesión. Verifica tus credenciales.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page page-center">
            <div className="container container-tight py-4">
                <div className="text-center mb-4">
                    {/* Logo de React */}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-11.5 -10.23174 23 20.46348" style={{ width: '80px', height: '80px', margin: '0 auto' }}>
                        <circle cx="0" cy="0" r="2.05" fill="#61dafb"/>
                        <g stroke="#61dafb" strokeWidth="1" fill="none">
                            <ellipse rx="11" ry="4.2"/>
                            <ellipse rx="11" ry="4.2" transform="rotate(60)"/>
                            <ellipse rx="11" ry="4.2" transform="rotate(120)"/>
                        </g>
                    </svg>
                    <p className="text-muted mt-3">Inicia sesión para continuar</p>
                </div>
                <div className="card card-md">
                    <div className="card-body">
                        <h2 className="h2 text-center mb-4">Iniciar Sesión</h2>
                        <form onSubmit={handleSubmit} autoComplete="off">
                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="tu@email.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    autoComplete="off"
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Contraseña</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Tu contraseña"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    autoComplete="new-password"
                                />
                            </div>
                            {error && <div className="alert alert-danger">{error}</div>}
                            <div className="form-footer">
                                <button
                                    type="submit"
                                    className="btn btn-primary w-100"
                                    disabled={loading}
                                >
                                    {loading ? 'Iniciando sesión...' : 'Entrar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;